<template>
  <v-form @submit.native.prevent="submit">
    <template v-if="isReady && isInitPasswordTokenValid">
      <v-row no-gutters justify="center" align="center" class="pb-5">
        <h3>Nouveau mot de passe</h3>
      </v-row>
      <v-alert type="info" text color="white" class="mb-5">6 caractères minimum</v-alert>
      <v-alert type="error" text class="mb-5" v-if="isServerError">Impossible de définir le mot de passe</v-alert>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="password"
          type="password"
          :error="isPasswordError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          autofocus
          placeholder="Mot de passe"
          prepend-inner-icon="lock"
        />
      </v-row>
      <v-row no-gutters justify="center" align="center">
        <v-text-field
          v-model="repeatPassword"
          type="password"
          :error="isRepeatPasswordError"
          :disabled="isSubmitting"
          dark
          outlined
          flat
          placeholder="Répétez le mot de passe"
          prepend-inner-icon="lock"
        />
      </v-row>
      <v-btn
        type="submit"
        dark
        large
        block
        depressed
        :loading="isSubmitting"
        :disabled="!arePasswordsValid"
        class="n-secondary-btn"
      >
        Valider le mot de passe
      </v-btn>
    </template>
    <template v-else-if="!isReady">
      <v-row no-gutters justify="center" align="center" class="py-8">
        <v-progress-linear indeterminate color="white" style="width: 240px; max-width: 75%"/>
      </v-row>
    </template>
    <template v-else>
      <v-alert type="error" text color="white" class="mb-5">Ce lien n'est pas valide</v-alert>
    </template>
    <v-row no-gutters justify="center" align="center">
      <v-btn
        text
        :disabled="isSubmitting"
        color="grey lighten-1"
        class="n-btn mt-3"
        :to="{ name: `login` }"
      >
        <v-icon class="mr-1">chevron_left</v-icon>
        Retour à la connexion
      </v-btn>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: `ForgotPassword`,

  data: () => ({
    isReady: false,
    isPasswordError: false,
    isRepeatPasswordError: false,
    isServerError: false,
    isSubmitting: false,
  }),

  computed: {
    initPasswordToken: {
      get() { return this.$store.state[`ui/login`].repeatPassword; },
      set(value) { this.$store.commit(`ui/login/SET_INIT_PASSWORD_TOKEN`, value); },
    },
    isInitPasswordTokenValid: {
      get() { return this.$store.state[`ui/login`].isInitPasswordTokenValid; },
      set(value) { this.$store.commit(`ui/login/SET_IS_INIT_PASSWORD_TOKEN_OK`, value); },
    },
    password: {
      get() { return this.$store.state[`ui/login`].password; },
      set(value) { this.$store.commit(`ui/login/SET_PASSWORD`, value); },
    },
    repeatPassword: {
      get() { return this.$store.state[`ui/login`].repeatPassword; },
      set(value) { this.$store.commit(`ui/login/SET_REPEAT_PASSWORD`, value); },
    },
    ...mapState(`model/auth`, [`accessToken`]),
    isPasswordLengthValid() {
      return this.password.length >= 6;
    },
    doPasswordsMatch() {
      return this.password === this.repeatPassword;
    },
    arePasswordsValid() {
      return this.isPasswordLengthValid && this.doPasswordsMatch;
    },
  },

  methods: {
    async submit() {
      this.isPasswordError = false;
      this.isRepeatPasswordError = false;
      this.isServerError = false;

      if (!this.arePasswordsValid) {
        this.isPasswordError = true;
        this.isRepeatPasswordError = true;
      }

      if (this.isPasswordError || this.isRepeatPasswordError) { return; }

      this.isSubmitting = true;
      await this.$store.dispatch(`ui/login/setPassword`);
      await this.$store.dispatch(`ui/login/login`);
      this.isSubmitting = false;

      if (!this.accessToken) {
        this.isServerError = true;
      } else {
        this.$router.replace({ name: `home` });
      }
    },
  },

  async beforeMount() {
    this.isReady = false;
    this.initPasswordToken = this.$route.query.token || null;
    await this.$store.dispatch(`ui/login/testInitPasswordToken`);
    this.isReady = true;
  },
};
</script>

<style lang="scss">
</style>
